var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWindows(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_143_569)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 13V20.434C21 20.6354 20.9594 20.8348 20.8807 21.0202C20.8019 21.2056 20.6867 21.3733 20.5417 21.5132C20.3968 21.6531 20.2252 21.7623 20.0371 21.8345C19.849 21.9066 19.6483 21.9401 19.447 21.933L19.314 21.922L12 21.008V13H21ZM10 13V20.758L4.752 20.102C4.26821 20.0415 3.82316 19.8064 3.50052 19.4409C3.17789 19.0753 2.99989 18.6045 3 18.117V13H10ZM19.314 2.07798C19.5139 2.05301 19.7167 2.06855 19.9105 2.12368C20.1042 2.1788 20.2849 2.27239 20.4416 2.39884C20.5984 2.5253 20.7281 2.68204 20.823 2.85971C20.9179 3.03738 20.9761 3.23235 20.994 3.43298L21 3.56598V11H12V2.99198L19.314 2.07798ZM10 3.24198V11H3V5.88298C2.99989 5.39542 3.17789 4.92461 3.50052 4.55907C3.82316 4.19353 4.26821 3.95843 4.752 3.89798L10 3.24198Z",
    fill: "#4A47E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_143_569"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindows);
export default __webpack_public_path__ + "static/media/windows.a7def620.svg";
export { ForwardRef as ReactComponent };